import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { PDialogFooterBtnActionType, PDialogFooterBtnConfig } from '../p-dialog-footer-btn-config.interface';

@Component({
    selector: 'p-key-value-viewer-dialog',
    template: `<p-dialog-container>
        <p-dialog-header title="{{ dialogData.objectName }}"></p-dialog-header>
        <div class="p-dialog-content simple-dialog-body">
            <p-key-value-viewer [values]="dialogData.data | pKeyValueSensitiveConvertor"></p-key-value-viewer>
        </div>
        <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
    </p-dialog-container>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PKeyValueViewerDialogComponent {
    public readonly footerConfig: PDialogFooterBtnConfig[] = [
        {
            type: PDialogFooterBtnActionType.Close,
            text: 'Actions.close'
        }
    ];

    constructor(@Inject(MAT_DIALOG_DATA) public dialogData: KeyValueViewerDialogData) {}
}

export type KeyValueViewerDialogData = {
    objectName: string;
    data: Record<string, unknown>;
};
